import React from 'react';
import buildResourcePath from '@lib/buildResourcePath'
import MyAccountCard from './MyAccountCard';
import * as Row from '../layout/Row';
import Button from '../common/Button';

export default class MyAccountPersonalInformationCard extends MyAccountCard {
    title = __('Personal information')
    endpoint = 'MyAccount'

    state = {
        email: this.props.model.email || '',
        name: this.props.model.name || '',
        lastName: this.props.model.lastName || '',
        company: this.props.model.company || '',
        language: this.props.defaultSettingsModel.language.model,
        market: this.props.defaultSettingsModel.market.model,
        measuringSystem: this.props.defaultSettingsModel.measuringSystem.model,
        documentNotifications: this.props.defaultSettingsModel.documentNotifications.model,
        newMessageEmailNotification: this.props.defaultSettingsModel.newMessageEmailNotification.model
    }

    renderBody() {
        return (
            <Row.Container hasOuterGutter={false} hasGutter={false}>
                <div className="column-6 column-xs-12">
                    {this.renderTextField(__('E-mail address'), this.state.email, newValue => this.setState({email: newValue}))}
                    {this.renderTextField(__('First name'), this.state.name, newValue => this.setState({name: newValue}))}
                </div>

                <div className="column-6 column-xs-12">
                    {this.renderTextField(__('Company'), this.state.company, newValue => this.setState({company: newValue}))}
                    {this.renderTextField(__('Last name'), this.state.lastName, newValue => this.setState({lastName: newValue}))}
                </div>

                <div className="column-6 column-xs-12" style={{marginTop: '1rem'}}>
                    {this.renderSelectField(__('Language'), this.state.language, this.props.defaultSettingsModel.language.items, newValue => this.setState({language: newValue}))}
                    {this.props.defaultSettingsModel.measuringSystem.meta.visible && this.renderSelectField(__('Measuring system'), this.state.measuringSystem, this.props.defaultSettingsModel.measuringSystem.items, newValue => this.setState({measuringSystem: newValue}))}
                    {this.props.defaultSettingsModel.documentNotifications.meta.visible && this.renderEnumFlagsField(__('Notify me about changes in following documents I am involved in:'), this.state.documentNotifications, this.props.defaultSettingsModel.documentNotifications.items, newValue => this.setState({documentNotifications: newValue}))}
                    {this.renderCheckboxField(this.props.defaultSettingsModel.newMessageEmailNotification.meta.name, this.state.newMessageEmailNotification, newValue => this.setState({newMessageEmailNotification: newValue}))}
                </div>

                <div className="column-6 column-xs-12" style={{marginTop: '1rem'}}>
                    {this.props.defaultSettingsModel.market.meta.visible && this.renderSelectField(__('Market'), this.state.market, this.props.defaultSettingsModel.market.items, newValue => this.setState({market: newValue}))}
                </div>
            </Row.Container>
        )
    }


    getModel() {
        return {
            UserData: {
                Email: this.state.email,
                Name: this.state.name,
                LastName: this.state.lastName,
                Company: this.state.company
            },

            DefaultSettings: {
                Language: this.state.language,
                Market: this.state.market,
                MeasuringSystem: this.state.measuringSystem,
                DocumentNotifications: this.state.documentNotifications,
                NewMessageEmailNotification: this.state.newMessageEmailNotification
            },

            __RequestVerificationToken: 'x'
        }
    }
}
